import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import baseUrl from "../../../../api/baseUrl";
import { RootState } from "../../../../redux/store";
import { LoggedInClinic, resolveLoggedInClinic } from "./getLoggedInClinic";

export function useLoggedInClinic(enabled = true): LoggedInClinic {
  const printClinic = useSelector((state: RootState) => state.print.clinic);
  const [bill, setBill] = useState<any>(null);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    baseUrl
      .get("/clinic/getBillData")
      .then((response) => {
        if (!cancelled) setBill(response?.data?.data ?? null);
      })
      .catch(() => {
        if (!cancelled) setBill(null);
      });
    return () => {
      cancelled = true;
    };
  }, [enabled]);

  return useMemo(
    () => resolveLoggedInClinic(bill, printClinic),
    [bill, printClinic]
  );
}
